import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DropdownControl } from '@anecdotes/design-system/dropdown-menu';
import {
  PLUGIN_ACCOUNT_CONTROL_NAME,
  PluginAccountDropdownFormExtensionComponent,
} from '../plugin-account-dropdown/plugin-account-dropdown.component';

@Component({
  selector: 'app-plugin-account-dropdown-control',
  templateUrl: './plugin-account-dropdown-control.component.html',
  standalone: false,
})
export class PluginAccountDropdownControlComponent
  extends PluginAccountDropdownFormExtensionComponent
  implements OnInit {
  @Input()
  serviceId: string;

  @Input()
  isServiceMultiAccount = true;

  @Input()
  name = PLUGIN_ACCOUNT_CONTROL_NAME;

  @Output()
  valueChange = new EventEmitter<string>();

  control: DropdownControl;

  ngOnInit(): void {
    this.control = this.onInit(this.serviceId, this.isServiceMultiAccount, (selectedServiceInstanceId) => {
      this.valueChange.emit(selectedServiceInstanceId);
    });
  }
}
